import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const About = () => {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Confiabilidade',
      description: 'Compromisso com a entrega de serviços consistentes e de alta qualidade',
    },
    {
      icon: 'ri-award-line',
      title: 'Excelência',
      description: 'Busca contínua pela melhoria e superação de expectativas',
    },
    {
      icon: 'ri-user-star-line',
      title: 'Profissionalismo',
      description: 'Equipes treinadas e processos estruturados para cada operação',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="relative bg-primary pt-32 pb-24 overflow-hidden">
        <div className="relative w-full px-12 lg:px-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl"
          >
            <span className="inline-block text-xs font-semibold tracking-[0.2em] text-white/40 uppercase mb-4">
              Institucional
            </span>
            <h1 className="text-4xl lg:text-5xl font-medium text-white leading-tight mb-6">
              Sobre o<br />Grupo Prime
            </h1>
            <p className="text-white/60 text-lg max-w-xl">
              Estrutura corporativa e excelência operacional para eventos e empresas
            </p>
          </motion.div>
        </div>
      </section>

      {/* Narrative */}
      <section className="py-24 lg:py-32">
        <div className="w-full px-12 lg:px-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="relative aspect-[4/5] rounded-2xl overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/c3572f2fc7991bc482df5952ce7ff02c/e77b859abd014f28dd2fa865cb78aaac.jpeg"
                  alt="Grupo Prime"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="space-y-8"
            >
              <div>
                <span className="inline-block text-xs font-semibold tracking-[0.2em] text-secondary/60 uppercase mb-4">
                  Nossa História
                </span>
                <h2 className="text-2xl lg:text-3xl font-medium text-primary leading-tight">
                  União estratégica de<br />
                  <span className="text-secondary/40">empresas especializadas</span>
                </h2>
              </div>

              <p className="text-secondary text-lg leading-relaxed">
                O Grupo Prime representa a união estratégica de empresas especializadas em operações corporativas de alto padrão. Fundado com o propósito de oferecer soluções integradas e eficientes, o grupo consolidou-se como referência em excelência operacional.
              </p>

              <p className="text-secondary text-lg leading-relaxed">
                Nossa estrutura corporativa foi desenvolvida para conectar diferentes especialidades sob um único padrão de qualidade, garantindo que cada operação seja executada com precisão, organização e cuidado técnico.
              </p>

              <div className="bg-accent rounded-xl p-8">
                <p className="text-primary text-xl font-medium leading-relaxed italic">
                  "Nosso compromisso é transformar operações complexas em experiências fluidas, garantindo tranquilidade e eficiência em cada projeto."
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Structure */}
      <section className="bg-light py-24 lg:py-32">
        <div className="w-full px-12 lg:px-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <span className="inline-block text-xs font-semibold tracking-[0.2em] text-secondary/60 uppercase mb-4">
              Estrutura
            </span>
            <h2 className="text-2xl lg:text-3xl font-medium text-primary">
              Estrutura Integrada
            </h2>
          </motion.div>

          <div className="flex flex-col lg:flex-row items-center justify-center gap-8">
            {/* Vallet Prime */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl p-8 w-full lg:w-72 text-center shadow-sm"
            >
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
                <i className="ri-car-line text-2xl text-primary"></i>
              </div>
              <h3 className="font-semibold text-xl text-primary mb-2">
                Vallet Prime
              </h3>
              <p className="text-secondary text-sm">
                Valet Parking &<br />Motorista Executivo
              </p>
            </motion.div>

            {/* Connector */}
            <div className="hidden lg:block w-16 h-0.5 bg-secondary/20"></div>

            {/* Grupo Prime */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-primary rounded-2xl p-10 w-full lg:w-80 text-center shadow-xl"
            >
              <div className="w-16 h-16 rounded-xl bg-accent flex items-center justify-center mx-auto mb-6">
                <span className="font-bold text-2xl text-primary">GP</span>
              </div>
              <h3 className="font-semibold text-2xl text-white mb-2">
                Grupo Prime
              </h3>
              <p className="text-white/60 text-sm">
                Estrutura Corporativa<br />Integrada
              </p>
            </motion.div>

            {/* Connector */}
            <div className="hidden lg:block w-16 h-0.5 bg-secondary/20"></div>

            {/* TR Prorok */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl p-8 w-full lg:w-72 text-center shadow-sm"
            >
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
                <i className="ri-truck-line text-2xl text-primary"></i>
              </div>
              <h3 className="font-semibold text-xl text-primary mb-2">
                TR Prorok
              </h3>
              <p className="text-secondary text-sm">
                Logística &<br />Movimentação
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 lg:py-32">
        <div className="w-full px-12 lg:px-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <span className="inline-block text-xs font-semibold tracking-[0.2em] text-secondary/60 uppercase mb-4">
              Princípios
            </span>
            <h2 className="text-2xl lg:text-3xl font-medium text-primary mb-4">
              Nossos Valores
            </h2>
            <p className="text-secondary text-lg max-w-xl mx-auto">
              Princípios que guiam todas as nossas operações
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="text-center group"
              >
                <div className="w-20 h-20 rounded-2xl bg-light flex items-center justify-center mx-auto mb-8 group-hover:bg-primary group-hover:scale-110 transition-all duration-500">
                  <i className={`${value.icon} text-3xl text-primary group-hover:text-white transition-colors duration-500`}></i>
                </div>
                <h3 className="font-semibold text-xl text-primary mb-4">
                  {value.title}
                </h3>
                <p className="text-secondary text-sm leading-relaxed max-w-xs mx-auto">
                  {value.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      
      {/* Botão Flutuante WhatsApp */}
      <a
        href="https://wa.me/5541997438126"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 bg-[#25D366] text-white w-14 h-14 rounded-full flex items-center justify-center shadow-xl hover:bg-[#20BA5A] hover:scale-110 transition-all duration-300 z-50 cursor-pointer"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>
    </div>
  );
};

export default About;
